import React from 'react';
import { CardHeader, CardText, Card, FontIcon } from 'material-ui';
import pluralize from 'pluralize';
import R from 'ramda';
import SingleLocList from './single-loc';
const propTypes = {
  locationName: React.PropTypes.string,
  docs: React.PropTypes.array,
  onExpandChange: React.PropTypes.func,
  expanded: React.PropTypes.bool,
  templateLength: React.PropTypes.number,
  draftLength: React.PropTypes.number,
  actions: React.PropTypes.object,
};

const LocationGroup = ({ locationName, docs, onExpandChange, expanded, actions }) => {
  if (R.isEmpty(docs)) return <div/>;
  return (<Card onExpandChange={onExpandChange} expanded={expanded} style={{ boxShadow: 'none', borderBottom: '1px solid #e0e0e0' }}>
    <CardHeader
      title={<div style={{ color: 'rgba(0, 0, 0, 0.64)' }}>
        <FontIcon className="tc-icon-location_on" color="rgba(0, 0, 0, 0.64)"/>
        {locationName}
      </div>}
      subtitle={<div style={{ paddingLeft: '30px' }}>
        {docs.length} {pluralize('template', docs.length)}
      </div>}
      style={{ padding: '8px 16px' }}
      actAsExpander
      showExpandableButton
    />
    <CardText
      expandable
      style={{ paddingTop: '0px' }}
    >
      <SingleLocList
        docs={docs}
        showLocName={false}
        {...actions}
      />
    </CardText>
  </Card>);
};
LocationGroup.propTypes = propTypes;
export default LocationGroup;



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/list/location-group.jsx